// extracted by mini-css-extract-plugin
export default {"ProteccionDeDatos":"ProteccionDeDatos_ProteccionDeDatos__w2M-i"};